// extracted by mini-css-extract-plugin
module.exports = {"container":"_3tGzQ","header":"_2NWYj","label":"_3C6jQ","amount":"_2Lxdp","controls":"_1kO8W","button":"_2T-yj","plus":"_3cLGT","minus":"_b82S","minMaxContainer":"_1Qojj"};